import React from "react";
import {Button, Form, InputNumber,Tooltip} from "antd";
import {WasteStreamGet, WasteStreamPost, WasteStreamRemove, WasteStreamUpdate} from "../../../../models/waste_stream";
import {ServiceUpdate} from "../../../../models/service";
const FormItem = Form.Item;

class EditQuantityForm extends React.Component {
    state = {
    editText:false,
      ws_id:'',
  };

   updateWasteStream = (index, id) => {
      this.setFieldEdit(true);
      const {service} = this.props;
      this.setState({ws_id: id});
      const waste_stream=service.waste_data[index]
      this.props.form.setFieldsValue({
      quantity: waste_stream.quantity,
      price: waste_stream.price,
      container_size: waste_stream.container_size,
      });
    };
   SubmitWasteStream = () => {
    let {ws_id} = this.state;
    let {service} = this.props;
    const manifest = service.id;
    const {form} = this.props;
    form.validateFields((err, values) => {
      let ws_ids = service.waste_data.map(ws => ws.id);
        if (!err) {
          if (ws_id) {
          values['price'] = values['price'] || null;
          values['quantity'] = values['quantity'] || null;
          WasteStreamUpdate(ws_id, values)
            .then(response => {
              service.waste_data.forEach((ws, sub_index) => {
                if (ws.id === response.id) {
                  WasteStreamGet(ws.id)
                    .then(response => {
                      service.waste_data[sub_index] = response.data;
                      this.props.updateService({service})
                    })
                }
              });
              form.resetFields();
            })
          this.setFieldEdit(false)
        }
        }
    });
  };

  removeWasteStream = (index, id) => {
    let {service} = this.props;
    if (id)
      WasteStreamRemove(id);
    service.waste_data.splice(index, 1);
    this.props.updateService({service})
  };
    setFieldEdit=(edit)=>{
    this.setState({editText:edit})
  }
  render() {
    const {editText,ws_id} = this.state;
    const {service} = this.props;
    const {getFieldDecorator} = this.props.form;
    return (
      <div className="scroll-ws-part">
        <div className="row">
          <div className="col-12">
            <h6>Manifest Number: </h6>
            <p>{service.manifest_number}</p>
          </div>
          <div className="row padding-0 margin-0">
            <div className="added-ws-div">
              <p className="ws-data added-ws-h bg-trans">Added Waste Stream</p>
              {service.waste_data && service.waste_data.map((ws, index) => <div key={index} className="ws-content">
                  <p className="ws-data bg-trans">
                    <span className="ws-name">Waste Stream</span>
                    <span>Quantity</span>
                    <span>Price</span>
                    <span>Container #</span>
                    <span className="ws-edit">{editText && ws_id === ws.id ? 'Save' : 'Edit'}</span>
                    <span className="ws-edit">{editText &&  ws_id === ws.id ? 'Cancel' : 'Delete'}</span>
                  </p>
                  <div className="ws-data ws-tbody">
                    <span>
                      <p>{ws.waste_stream ? ws.waste_stream.code : ''} - {ws.waste_stream ? ws.waste_stream.unit : ''} - {ws.waste_stream.container ? ws.waste_stream.container.name : ''}</p>
                    </span>
                    <span className={editText && ws_id === ws.id ? "editable-show":"data-show"}>
                       <FormItem>
                          <Tooltip title="Estimated gallons picked up">
                            {getFieldDecorator('quantity')(<InputNumber placeholder="Quantity"/>)}
                          </Tooltip>
                        </FormItem>
                        <p>{ws.quantity ? ws.quantity : '-'}</p>
                    </span>
                    <span className={editText && ws_id === ws.id ? "editable-show":"data-show"}>
                      <FormItem>
                      {getFieldDecorator('price',)(<InputNumber placeholder="Price" min={0} step={0.1}/>)}
                      </FormItem>
                      <p>{ws.price ? ws.price : '-'}</p>
                    </span>
                    <span className={editText && ws_id === ws.id ? "editable-show":"data-show"}>
                      <FormItem>
                        {getFieldDecorator('container_size')(<InputNumber placeholder="Containers"/>)}
                      </FormItem>
                      <p>{ws.container_size ? ws.container_size : '-'}</p>
                    </span>
                    <span className="ws-edit">
                       {editText && ws_id === ws.id ?<Button type="primary" className="action-ws-btn" onClick={this.SubmitWasteStream}
                                htmlType='button'>Save</Button> :
                       <Button className="action-ws-btn" onClick={() => this.updateWasteStream(index, ws.id)}
                                htmlType='button'><i className="fa fa-edit"/></Button>}
                      </span>
                     <span className="ws-edit">
                      {editText && ws_id === ws.id ? <Button className="action-ws-btn" onClick={() => this.setFieldEdit(false)}
                                htmlType='button'>Cancel</Button> :
                       service.waste_data.length > 1 ? <Button className="action-ws-btn" onClick={() => this.removeWasteStream(index, ws.id)}
                                htmlType='button'><i className="fa fa-trash"/></Button>: ''}
                      </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const EditQuantity = Form.create()(EditQuantityForm);


// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/hotsheet_performed/EditQuantity.jsx